import { Box, Typography } from '@mui/material';
import { MdForwardToInbox } from 'react-icons/md';
import Header from '@/Components/MagicLink/Header';
import RequestCard from '@/Components/MagicLink/RequestCard';
import IdCardIcon from '@/Components/MagicLink/IdCardIcon';
import Section from '@/Components/MagicLink/Section';
import CancelRequestButton from '@/Components/MagicLink/CancelRequestButton';
import PrimaryActionButton from '@/Components/MagicLink/PrimaryActionButton';
import { useMagicLinkAppProvider, MagicLinkView } from '@/Provider/MagicLinkAppProvider';
import {
    magicLinkCenteredHeroInnerSx,
    magicLinkPageColumnSx,
    magicLinkPageOuterSx,
} from '@/Utils/MagicLink/pageLayout';

const IntroStepView = () => {
    const { magicLinkData, requestDetail, navigateToView } = useMagicLinkAppProvider();

    // ID card is required if either front or back side hasn't been uploaded yet
    const isIdCardRequired = !magicLinkData?.idCardFrontUploaded || !magicLinkData?.idCardBackUploaded;

    const headline = isIdCardRequired
        ? 'Nahratie občianskeho preukazu'
        : 'Potvrdenie žiadosti';

    const description = isIdCardRequired
        ? 'Pre pokračovanie, prosím, nahrajte svoj občiansky preukaz. Ak si nie ste vedomý žiadnej požiadavky na zmenu alebo ste o ňu nežiadali, môžete kliknutím na tlačidlo „Zrušiť žiadosť" proces ukončiť.'
        : 'Skontrolujte si, prosím, svoju žiadosť. Ak si nie ste vedomý žiadnej zmeny alebo ste o žiadnu zmenu poisťovňu nežiadali, prosím kliknite na tlačidlo „Zrušiť žiadosť".';

    return (
        <Box component="main" sx={magicLinkPageOuterSx}>
            <Box sx={magicLinkPageColumnSx}>
                    {/* Centered hero — logo at the top of the group, Section card in
                        the middle, action footer rendered below the section. */}
                    <Box sx={magicLinkCenteredHeroInnerSx}>
                        <Header />

                        {/* Section header mirrors the icon + headline row pattern
                            defined in `Section.tsx` (icon to the left of the title).
                            Description lives in the section body underneath. */}
                        <Section
                            icon={<IdCardIcon height={32} width="auto" />}
                            title={headline}
                        >
                            <Typography variant="body2" color="text.secondary">
                                {description}
                            </Typography>

                            {requestDetail && (
                                <RequestCard
                                    icon={MdForwardToInbox}
                                    headline={requestDetail.headline}
                                    description={requestDetail.description}
                                    attachmentCount={requestDetail.attachmentCount}
                                    attachmentCountLabel={requestDetail.attachmentCountLabel}
                                    onClick={() => navigateToView(MagicLinkView.REQUEST_DETAIL)}
                                />
                            )}
                        </Section>

                        {/* Footer button row — placed outside the Section. Mirrors the
                            `SignatureFlowFooters` pattern from RequestFormLib: right
                            aligned row on >= sm, stacked + stretched on xs with the
                            primary action on top via `column-reverse`. */}
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column-reverse', sm: 'row' },
                                alignItems: { xs: 'stretch', sm: 'center' },
                                justifyContent: 'flex-end',
                                flexWrap: 'wrap',
                                gap: 2,
                                width: '100%',
                            }}
                        >
                            <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>
                                <CancelRequestButton fullWidth />
                            </Box>
                            <Box
                                sx={{
                                    width: { xs: '100%', sm: 'auto' },
                                    minWidth: { sm: 220 },
                                }}
                            >
                                <PrimaryActionButton fullWidth />
                            </Box>
                        </Box>
                    </Box>
            </Box>
        </Box>
    );
};

export default IntroStepView;
